/** 行 click/dblclick 捕获阶段需忽略的目标（避免误触发行选中/双击编辑） */
const INTERACTIVE_TARGET_SELECTOR = [
  'button',
  'input',
  'textarea',
  '.z-checkbox',
  '.z-switch',
  '.z-input',
  '.z-input-number',
  '.z-date-editor',
  '.z-upload',
  '.z-grid__detail-link',
].join(', ')

export function isGridInteractiveTarget(target: EventTarget | null) {
  const element =
    target instanceof HTMLElement
      ? target
      : target instanceof Node
        ? target.parentElement
        : null
  if (!element) {
    return false
  }
  return !!element.closest(INTERACTIVE_TARGET_SELECTOR)
}
